module.exports = __webpack_public_path__ + "img/comment.afde52d8.svg";